import { useEffect, useRef, useState, type ReactNode } from "react";

interface Props {
  label: ReactNode;
  disabled?: boolean;
  title?: string;
  buttonClassName?: string;
  panelClassName?: string;
  children: ReactNode;
}

export default function Dropdown({ label, disabled, title, buttonClassName = "", panelClassName = "", children }: Props) {
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!open) return;
    const onClick = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) {
        setOpen(false);
      }
    };
    const onKey = (e: KeyboardEvent) => {
      if (e.key === "Escape") setOpen(false);
    };
    document.addEventListener("mousedown", onClick);
    document.addEventListener("keydown", onKey);
    return () => {
      document.removeEventListener("mousedown", onClick);
      document.removeEventListener("keydown", onKey);
    };
  }, [open]);

  return (
    <div className="relative" ref={ref}>
      <button
        onClick={() => setOpen(!open)}
        disabled={disabled}
        title={title}
        className={`btn-quiet text-sm px-4 py-2 text-left flex items-center justify-between ${buttonClassName}`}
      >
        {label}
        <span className="ml-1.5 text-xl leading-none">▾</span>
      </button>
      {open && (
        <div
          className={`absolute right-0 top-full mt-2 w-52 max-h-72 overflow-y-auto rounded-xl border border-border shadow-lg z-20 ${panelClassName}`}
          style={{ background: "var(--surface)" }}
        >
          {children}
        </div>
      )}
    </div>
  );
}
